import { LogoColor } from '@/components/Logo';

interface WelcomeMessageProps {
  sidebarOpen: boolean;
  sessionId?: string;
  onSidebarToggle: () => void;
}

export default function WelcomeMessage({ sidebarOpen, sessionId, onSidebarToggle }: WelcomeMessageProps) {
  if (sidebarOpen || sessionId) return null;

  return (
    <div className="absolute top-6 left-8 z-40">
      <div
        className="w-20 h-8 cursor-pointer hover:opacity-80 transition-opacity"
        onClick={onSidebarToggle}
      >
        <LogoColor className="w-full h-full" />
      </div>
    </div>
  );
}